import React from 'react';

import flashMessageStyles from '~/FlashMessage/styles.less';
import { Link } from '~/UI/Button';
import { LocationDescriptor } from 'history';

const LinkFlashMessage: React.FC<
	React.PropsWithChildren<{ link: LocationDescriptor; text: string; linkTitle: string }>
> = (props) => (
	<span>
		{`${props.text} `}
		<Link styles={flashMessageStyles} to={props.link} title={props.linkTitle}>
			{props.linkTitle}
		</Link>
	</span>
);

LinkFlashMessage.displayName = 'FlashMessage.LinkFlashMessage';

export default LinkFlashMessage;
